module.exports = __webpack_public_path__ + "static/media/img4.41c255b6.jpg";